import { useSelector } from 'react-redux';
import { Navigate, Outlet } from 'react-router';

import {
	selectAccountMembershipId,
	selectIsAuthenticated,
	selectIsLoadingUser,
} from '@shared/api/reduxToolkit';
import { PATHS } from '@shared/constants';

export const PublicRoute = () => {
	const isAuth = useSelector(selectIsAuthenticated);
	const accountMembershipId = useSelector(selectAccountMembershipId);
	const isLoadingUser = useSelector(selectIsLoadingUser);

	if (isAuth && isLoadingUser) {
		return null;
	}

	if (isAuth && accountMembershipId) {
		return <Navigate to={`/${accountMembershipId}/${PATHS.user.PROFILE}`} replace />;
	}

	return <Outlet />;
};
